export default __webpack_public_path__ + "static/media/rl.145648b5.png";